import { ActivatedRoute, Router } from '@angular/router';

/**
 * Depth first search from the router root to find the first node of the given type. There
 * should only be one in the tree.
 *
 * @param router the router instance
 * @param routeNodeType the type of route node to find
 * @returns
 */
export function findRelativeActivatedRoute(
    router: Router,
    routeNodeType = 'dashboard'
): ActivatedRoute | null {
    return findActivatedRoute(router.routerState.root, routeNodeType);
}

function findActivatedRoute(
    current: ActivatedRoute,
    routeNodeType: string
): ActivatedRoute | null {
    if (current.snapshot.data?.routeNodeType === routeNodeType) {
        return current;
    }
    for (const child of current.children) {
        const result = findActivatedRoute(child, routeNodeType);
        if (result != null) {
            return result;
        }
    }
    return null;
}
